import ApexChartContainer from "../../../Components/Charts/ApexChart/ApexChart"

const ApexChart = () => {
  return (
    <div className='page-body'>
      <ApexChartContainer />
    </div>
  )
}

export default ApexChart